
import React, { useState, useEffect } from 'react';
import styles from '../Gstr-9c Reconciliation/GSTR-9B_recon.module.css';
import axios from '../../../../axios-order';
import Five from '../Gstr-9c Reconciliation/five';
import Seven from '../Gstr-9c Reconciliation/seven';
import Nine from '../Gstr-9c Reconciliation/nine';
import Eleven from '../Gstr-9c Reconciliation/eleven';
import Twelve from '../Gstr-9c Reconciliation/twelve';
import Fourteen from '../Gstr-9c Reconciliation/fourteen';
import Sixteen from '../Gstr-9c Reconciliation/sixteen';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Seventeen from './seventeen';
import Pvt from './ptv';

const GSTR9CReportData = () => {
  const [data, setData] = useState({ records: {} });
  const [error, setError] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const history = useHistory();

  const getCardColor = (index) => {
    const colors = [
      '#d7bde2', // Light purple
      '#a9cce3', // Light blue
      '#edbb99', // Light orange
      '#aed6f1', // Soft sky blue
      '#f9e79f', // Soft yellow
      '#a3e4d7', // Soft mint green
      '#f5b7b1', // Soft pink
      '#d5a6bd', // Soft mauve
      '#b7e4c7', // Soft sage green
      '#ffd3a5', // Soft peach
      '#c8a2c8', // Soft lavender
      '#b3d9ff', // Soft periwinkle
      '#e6ccb3', // Soft beige
      '#d4b5d4', // Soft orchid
      '#c7e9b4', // Soft lime green
    ];
    return colors[index % colors.length];
  };

  const getCardIcon = (index) => {
    const icons = [
      <svg key="financial-report" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-label="Financial Report">
        <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
        <path d="M8 8h8" />
        <path d="M8 12h8" />
        <path d="M8 16h4" />
        <path d="M16 16h2" />
      </svg>,
      <svg key="tax-calculation" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-label="Tax Calculation">
        <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
        <path d="M9 9h6v6H9z" />
        <path d="M10 10v4" />
        <path d="M12 10v4" />
        <path d="M14 10v4" />
        <path d="M10 12h4" />
      </svg>,
      <svg key="tax-liability" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-label="Tax Liability">
        <path d="M12 2a10 10 0 0 0-10 10c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2z" />
        <path d="M8 8c0 4 8 4 8 0" />
        <path d="M12 12v6" />
      </svg>,
      <svg key="itc-reconciliation" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-label="ITC Reconciliation">
        <path d="M4 4h16v16H4z" />
        <path d="M8 8h8v8H8z" />
        <path d="M10 10v4" />
        <path d="M14 10v4" />
      </svg>,
    ];
    return icons[index % icons.length];
  };

  const get_gstr9_report_data = () => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    const gstr9c_recon_id = localStorage.getItem('gstr9c_recon_id');
    console.log('gstr9c_recon_id:', gstr9c_recon_id);

    if (!business_entity_id) {
      setError('business_entity_id is missing in localStorage');
      return;
    }

    if (!gstr9c_recon_id) {
      setError('gstr9c_recon_id is missing in localStorage');
      return;
    }

    const payload = {
      business_entity_id: business_entity_id,
      gstr9c_recon_id: gstr9c_recon_id
    };

    axios
      .post('/get_gstr9c_table_details', payload)
      .then((res) => {
        console.log('API Response:', JSON.stringify(res.data, null, 2));
        setData(res.data);
        setError(null);
      })
      .catch((error) => {
        console.error('Error fetching data:', error.message);
        setError('Failed to fetch data. Check the API endpoint or server.');
      });
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleBack = () => {
    history.goBack();
  };

  const handleExport = () => {
    const filename = `GSTR 9C Report.xlsx`;
    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const gstr9cReconIds = JSON.parse(localStorage.getItem('gstr9c_recon_ids') || '[]');
    const gstr9cReconId = gstr9cReconIds.length > 0 ? gstr9cReconIds[0] : null;
    const payload = {
      business_entity_id: localStorage.getItem('business_entity_id'),
      gstr9c_recon_id: localStorage.getItem('gstr9c_recon_id')
    };

    axios
      .post(`/gstr9c_excel_report`, {
        ...payload,
      })
      .then((res) => {
        downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        // toast.error("Server Error, Try After Some Time", { autoClose: 3000 });
      });
  };

  useEffect(() => {
    get_gstr9_report_data();
  }, []);

  const handleCardClick = (sectionTitle) => {
    console.log('Card clicked:', sectionTitle);
    console.log('Available data for section:', JSON.stringify(data.records[sectionTitle], null, 2));
    setSelectedSection(sectionTitle);
  };

  const handleKeyDown = (event, sectionTitle) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick(sectionTitle);
    }
  };

  if (error) {
    return <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>{error}</div>;
  }

  if (selectedSection) {
    console.log('Selected section:', selectedSection);
    console.log('Data for selected section:', JSON.stringify(data.records[selectedSection], null, 2));

    const tableNumber = selectedSection.startsWith('5.') ? 'table5' :
      selectedSection.startsWith('7.') ? 'table7' :
        selectedSection.startsWith('9.') ? 'table9' :
          selectedSection.startsWith('11.') ? 'table11' :
            selectedSection.startsWith('12.') ? 'table12' :
              selectedSection.startsWith('14.') ? 'table14' :
                selectedSection.startsWith('16.') ? 'table16' :
                  selectedSection.startsWith('Pt.V.') ? 'V' :
                    selectedSection.startsWith('17.') ? 'table17' :
                      'table5';

    if (tableNumber === 'table5') {
      console.log('Rendering Five component');
      return (
        <Five
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          reasonsData={data.records["6.Reasons for Un - Reconciled difference in Annual Gross Turnover"]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table7') {
      console.log('Rendering Seven component');
      return (
        <Seven
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          reasonsData={data.records["8.Reasons for Un - Reconciled difference in Taxable Turnover"]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table9') {
      console.log('Rendering Nine component');
      return (
        <Nine
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          reasonsData={data.records["10.Reasons for Un - Reconciled Payment of Tax"]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table11') {
      console.log('Rendering Eleven component');
      return (
        <Eleven
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table12') {
      console.log('Rendering Twelve component');
      return (
        <Twelve
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          reasonsData={data.records["13.Reasons for Un - Reconciled difference in ITC"]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table14') {
      console.log('Rendering Fourteen component');
      return (
        <Fourteen
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          reasonsData={data.records["15.Reasons for Un - Reconciled difference in ITC"]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table16') {
      console.log('Rendering Sixteen component');
      return (
        <Sixteen
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }
    if (tableNumber === 'V') {
      console.log('Rendering Pt component');
      return (
        <Pvt
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }

    if (tableNumber === 'table17') {
      console.log('Rendering Fourteen component');
      return (
        <Seventeen
          handleBack={() => setSelectedSection(null)}
          updateTableData={null}
          data={data.records[selectedSection]}
          reasonsData={data.records["17.Late fee payable and paid"]}
          title={selectedSection}
          get_gstr9_report_data={get_gstr9_report_data}
        />
      );
    }


    console.log('Rendering Five component for:', selectedSection);
    return (
      <Five
        handleBack={() => setSelectedSection(null)}
        updateTableData={null}
        data={data.records[selectedSection]}
        title={selectedSection}
        get_gstr9_report_data={get_gstr9_report_data}
      />
    );
  }

  return (
    <>
      <div style={{ padding: '2px', backgroundColor: '#f8fafc' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button
            className="button-outlined-primary"
            style={{ marginLeft: "0px", width: "10%" }}
            onClick={handleBack}
          >
            BACK
          </button>
          <button
            className="button-outlined-primary"
            style={{ marginLeft: "0px", width: "10%" }}
            onClick={handleExport}
          >
            EXPORT
          </button>
        </div>
      </div>
      <div
        className={styles.cardContainer}
        style={{
          padding: '20px',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '15px',
        }}
      >
        {Object.keys(data.records)
          .filter(sectionTitle => ![
            "6.Reasons for Un - Reconciled difference in Annual Gross Turnover",
            "8.Reasons for Un - Reconciled difference in Taxable Turnover",
            "10.Reasons for Un - Reconciled Payment of Tax",
            "13.Reasons for Un - Reconciled difference in ITC",
            "15.Reasons for Un - Reconciled difference in ITC"
          ].includes(sectionTitle))
          .map((sectionTitle, index) => (
            <div
              key={index}
              className={`${styles.card} card-${index + 5}`}
              style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                borderRadius: '20px',
                padding: '0',
                minWidth: '280px',
                flex: '1 1 calc(33.33% - 10px)',
                maxWidth: 'calc(33.33% - 10px)',
                height: '320px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
                color: '#333',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              }}
              onClick={() => handleCardClick(sectionTitle)}
              onKeyDown={(e) => handleKeyDown(e, sectionTitle)}
              tabIndex={0}
              role="button"
              aria-label={`View details for ${sectionTitle}`}
            >
              <style>
                {`
                .card-${index + 5}:hover, .card-${index + 5}:focus {
                  transform: scale(1.02);
                  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
                }
                .card-${index + 5}:hover .card-background-${index + 5}, .card-${index + 5}:focus .card-background-${index + 5} {
                  background: linear-gradient(135deg, ${getCardColor(index)} 0%, ${getCardColor(index)}FF 100%);
                }
              `}
              </style>
              <div
                className={`card-background-${index + 5}`}
                style={{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  width: '60%',
                  height: '100%',
                  background: `linear-gradient(135deg, ${getCardColor(index)} 0%, ${getCardColor(index)}DD 100%)`,
                  borderRadius: '0 20px 20px 0',
                  clipPath: 'ellipse(70% 100% at 100% 0%)',
                  transition: 'background 0.2s ease',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '15px',
                  left: '15px',
                  color: '#999',
                  fontSize: '14px',
                }}
              >
                ↓
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  zIndex: 2,
                }}
              >
                {index + 1}
              </div>
              <div
                style={{
                  padding: '15px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                <div
                  style={{
                    marginTop: '40px',
                    marginBottom: '15px',
                    color: '#666',
                  }}
                >
                  {getCardIcon(index)}
                </div>
                <h3
                  style={{
                    margin: '0 0 8px 0',
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#333',
                  }}
                >
                  {sectionTitle}
                </h3>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#333',
                    marginBottom: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontWeight: 'bold',
                      marginBottom: '5px',
                    }}
                  >
                    <span>Description</span>
                    <span>Value</span>
                  </div>
                  {data.records[sectionTitle] &&
                    data.records[sectionTitle].slice(0, 2).map((item, itemIndex) => (
                      <div
                        key={itemIndex}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          marginTop: '3px',
                          fontSize: '11px',
                        }}
                      >
                        <span
                          style={{
                            maxWidth: '120px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.description}
                        </span>
                        <span>
                          ₹{(item.manual_input || item.taxable_non_taxable_value ||  item.amount_of_itc_total_manual || 0).toLocaleString()}
                        </span>
                      </div>
                    ))}
                  {data.records[sectionTitle] && data.records[sectionTitle].length > 2 && (
                    <p
                      style={{
                        marginTop: '3px',
                        fontSize: '10px',
                        color: '#666',
                      }}
                    >
                      +{data.records[sectionTitle].length - 2} more items
                    </p>
                  )}
                </div>
                <button
                  style={{
                    position: 'absolute',
                    bottom: '15px',
                    left: '15px',
                    background: `linear-gradient(135deg, ${getCardColor(index)} 0%, ${getCardColor(index)}AA 100%)`,
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '500',
                    zIndex: 2,
                    transition: 'background 0.2s ease',
                  }}
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default GSTR9CReportData;
